export default function KeineDaten () {
    return (
        <div>
            <h3><span style={{fontSize: '2em', paddingLeft: '2em'}}>&#128206;</span> Keine Daten unter dieser Filterung...</h3>
        </div>
    )
}